export const isScheduledPost = (post) =>
  !!post.scheduledFor && !post.publishedAt;

export const comparePostsByDate = (order) => (first, second) => {
  const firstDate = new Date(first.scheduledFor || first.createdAt);
  const secondDate = new Date(second.scheduledFor || second.createdAt);
  return order * (firstDate.getTime() - secondDate.getTime());
};
